import {
  ACTION_CREATE,
  ACTION_DETAILS,
  ACTION_UPDATE,
} from "models/role/action";
import { SUBJECT_CASH_MANAGEMENT_ACCOUNT } from "models/role/subject";
import { lazyRetry } from "utils/lazyRetry";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const CashManagementAccountCreate = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CashManagementAccount" */
      "../pages/account/Create"
    ),
  "CashManagementAccount"
);
const CashManagementAccountDetails = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CashManagementAccount" */
      "../pages/account/Details"
    ),
  "CashManagementAccount"
);
const CashManagementAccountEdit = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "CashManagementAccount" */
      "../pages/account/Edit"
    ),
  "CashManagementAccount"
);

export const accountRoutes: Route[] = [
  {
    i18nName: "Edit account - Cash management",
    path: PAGE_URLS.accountCreate,
    component: CashManagementAccountCreate,
    can: {
      do: ACTION_CREATE,
      on: SUBJECT_CASH_MANAGEMENT_ACCOUNT,
    },
  },
  {
    i18nName: "Edit account - Cash management",
    path: PAGE_URLS.accountDetails,
    component: CashManagementAccountDetails,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT_ACCOUNT,
    },
  },
  {
    i18nName: "Account details - Cash management",
    path: PAGE_URLS.accountEdit,
    component: CashManagementAccountEdit,
    can: {
      do: ACTION_UPDATE,
      on: SUBJECT_CASH_MANAGEMENT_ACCOUNT,
    },
  },
];
